import banners from './base64';

export const defaultReward = 100;

export const rewardFields = ['pitchMessage',
  'residentEnrollHeader',
  'emailBody',
  'emailSms',
  'bannerText',
  'residentDiscountEmailBody',
  'residentDiscountEmailSms',
  'friendInviteMenuBody',
  'popupMessage',
  'residentThankYouEmailBody']

export default {
  propertyId: window.location.pathname.split("/")[1],
  title: `Referral Campaign`,
  reward: defaultReward,
  image: banners.inviteBanner,
  emailSubject: "Refer Your Friends And Start Earning Rewards",
  emailBody: `We firmly believe that everything becomes better when you bring your friends! Imagine how amazing the world would be when your friends live in your community.<br><br>Refer your friends and earn %reward% discount on rent for every successful lease.<br><br><br>`,
  emailSms: `Imagine how amazing the world would be when your friends live in your community. Refer your friends and earn %reward% discount on rent for every successful lease.`,
  ctaDesign: "banner_with_cta",
  ctaText: "Refer Now",
  bannerText: `Refer a friend to get a %reward% discount on your next month’s rent`,
  pitchMessage: `Get a %reward% discount on your next month’s rent after your friend successfully leases in your community.`,
  residentEnrollHeader: `Friends make the best neighbors!! Refer a friend and earn %reward%.`,
  residentEnrollFooter: `Please add your email to enroll for this Referral Program`,
  emailEnabled: true,
  smsEnabled: false,
  facebookEnabled: true,
  twitterEnabled: true,
  residentInviteImage: banners.propertyBanner,
  friendInviteEmailHeader: "Join My Community and be my neighbor",
  residentInviteEmailSubject: "Join My Community and be my neighbor",
  residentInviteEmailBody: `I absolutely love my apartment and the community and I know you will love it too! We have the best pool, an awesome gym and really fun events. Plus, the apartments are amazing!<br><br>Please visit: Your referral link will be available after enrollment.`,
  residentInviteSms: `The only thing that could make %property% even more amazing is you!! You will love living here!`,
  residentInviteSocialContent: "Content",
  tourCtaText: "Take a Tour",
  tourCtaUrl: "http://hy.ly?utm_medium=Email&utm_source=Hyly&utm_campaign=eBlast&utm_content={%email_name_encoded%}-events",
  contactCtaText: "Contact Leasing",
  contactCtaUrl: "http://hy.ly?utm_medium=Email&utm_source=Hyly&utm_campaign=eBlast&utm_content={%email_name_encoded%}-events",
  residentDiscountImage: banners.discountBanner,
  residentDiscountEmailSubject: "Congratulations! Your friend has leased",
  residentDiscountEmailBody: `Hello {%hyraf_resident_name%},<br><br>Your friend {%hyraf_friend_name%} has leased. Here’s your reward.You will receive %reward% discount on your next month’s rent.<br><br>Refer more friends and continue saving on rent!<br><br><br>`,
  residentDiscountEmailSms: `Your friend {%hyraf_friend_name%} has leased. Here’s your reward. You will receive %reward% discount on your next month’s rent. Refer more friends and continue saving on rent!`,
  rewardEmailHeader: "You are rewarded!",
  friendInviteMenuHeader: "Share To Receive Reward",
  friendInviteMenuBody: "Invite friend to visit our community or share on social media. If they lease, you will receive %reward%.",
  popupTitle: "Thanks For Sharing",
  popupMessage: "You will get a %reward% discount once your friend leases",
  residentBannerTitle: "Refer A Friend, Get Rewarded",
  residentThankYouEmailSubject: "Thank you for enrolling to Avenue at York Referral Campaign",
  residentThankYouEmailTitle: "Thank you for enrolling",
  residentThankYouEmailBody: `Hello {%hyraf_resident_name%},<br><br>We firmly believe that everything becomes better when you bring your friends! Imagine how amazing the world would be when your friends live in your community.,<br><br>Refer your friends and earn %reward% discount on rent for every successful lease.`,
  residentThankYouImage: banners.thankYouBanner,
  landingPageContent: `I absolutely love my apartment and the community and I know you will love it too! We have the best pool, an awesome gym and really fun events. Plus, the apartments are amazing!  Come be my neighbour! I know you will love it!<br><br>I would recommend you to take a tour at your free time. Or, contact my community if you need to need human help. I’m pretty sure that you would enjoy your stay here and we’ll have fun together too!`,
  landingPageTitle: 'Hey, join my community',
  landingPageImage: banners.landingBanner,
  emailValidationStatus: false
}